import { Box, Tab, Tabs } from '@mui/material'
import {
	createFileRoute,
	Outlet,
	useNavigate,
	useParams,
} from '@tanstack/react-router'

const tabList = [
	{ label: 'Queues', value: 'queue' },
	// Add more tabs as needed
]

function EntityLayout() {
	const params = useParams({ strict: false })
	const entity = typeof params.entity === 'string' ? params.entity : undefined
	const tab = typeof params.tab === 'string' ? params.tab : undefined
	const navigate = useNavigate()
	const selectedTab = tab || tabList[0].value

	// biome-ignore lint/suspicious/noExplicitAny: MUI event handler type
	const handleTabChange = (_: any, newValue: string) => {
		if (entity) {
			navigate({
				to: `/${entity}/${newValue}`,
				params: { entity, tab: newValue },
				replace: false,
			})
		}
	}

	return (
		<Box>
			<Tabs value={selectedTab} onChange={handleTabChange}>
				{tabList.map((t) => (
					<Tab key={t.value} label={t.label} value={t.value} />
				))}
			</Tabs>
			<Box mt={2}>
				<Outlet />
			</Box>
		</Box>
	)
}

export const Route = createFileRoute('/_authenticated/$entity/layout')({
	component: EntityLayout,
})
